module.exports = __webpack_public_path__ + "img/no-backpack.44f824d6.png";